import { render } from "./Main.vue?vue&type=template&id=f1f8438e"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=f1f8438e&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__